/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SharedContactDealerWrapper_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespHeroCarouselRequestMoreImages_item$ref: FragmentReference;
export type PdpRespHeroCarouselRequestMoreImages_item = {|
  +serviceId: ?string,
  +$fragmentRefs: SharedContactDealerWrapper_item$ref,
  +$refType: PdpRespHeroCarouselRequestMoreImages_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespHeroCarouselRequestMoreImages_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '092c74d315099a40ad4b44ee46353114';
module.exports = node;
